import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user && roles.includes(user.role)) return children;
  return (
    <div className="flex flex-col items-center justify-center py-32 text-center" data-testid="forbidden-screen">
      <ShieldAlert size={48} className="text-sunset-accent mb-6" />
      <h1 className="font-serif text-4xl tracking-tight mb-3">Acceso restringido</h1>
      <p className="text-sunset-muted max-w-sm mb-8">No tienes permiso para ver esta sección con tu rol actual.</p>
      <Link to="/admin" className="bg-sunset-ink text-white kicker px-8 py-3.5 hover:bg-sunset-accent transition-colors">Volver al dashboard</Link>
    </div>
  );
}
